module.exports = __webpack_public_path__ + "static/media/SS.c7342644.jpg";